import { useState } from 'react';
import Card from 'antd/lib/card';
import Table from 'antd/lib/table';
import Switch from 'antd/lib/switch';
import { ColumnsType } from 'antd/lib/table/interface';
import { getYearlyTotals, ICalculateEventsResult, IYearlyTotals } from './calculatePriceResponseScenariosEvents';

interface IPriceResponseScenariosSummaryTableProps {
    events: ICalculateEventsResult;
    isDefinedMaxDispatchesPerDay: boolean;
    isLoading: boolean;
}

const hourFormatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const PriceResponseScenariosSummaryTable = ({ events, isDefinedMaxDispatchesPerDay, isLoading }: IPriceResponseScenariosSummaryTableProps) => {
    const [applyMaxDispatchPerDay, setApplyMaxDispatchPerDay] = useState(true);

    const rows = getYearlyTotals(applyMaxDispatchPerDay ? events.summaryWithCap : events.summaryWithoutCap);

    const columns: ColumnsType<IYearlyTotals> = [
        {
            title: 'Year',
            dataIndex: 'year',
            fixed: 'left',
            width: 80,
        },
        {
            title: 'Event Days',
            dataIndex: 'eventDays',
            align: 'right',
            render: (value: number) => (value ? value : '-'),
        },
        {
            title: 'Event Hours',
            dataIndex: 'eventHours',
            align: 'right',
            minWidth: 120,
            render: (value: number) => (value ? hourFormatter.format(value) : '-'),
        },
        {
            title: 'Savings',
            dataIndex: 'savings',
            align: 'right',
            minWidth: 120,
            render: (value: number) => (value ? currencyFormatter.format(value) : '-'),
        },
    ];

    return (
        <Card
            title="Savings Summary"
            style={{ marginBottom: 16 }}
            loading={isLoading}
            extra={
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                    <span>Apply Max Dispatch Per Day</span>
                    <Switch disabled={!isDefinedMaxDispatchesPerDay} checked={applyMaxDispatchPerDay} onChange={setApplyMaxDispatchPerDay} />
                </label>
            }
        >
            <Table<IYearlyTotals> size="small" rowKey="key" columns={columns} dataSource={rows} pagination={false} />
        </Card>
    );
};
